import React, { useContext } from "react";
import { useField } from "react-final-form";
import { Radio } from "components/Form/Field";
import { IntlContext } from "context";
import { SubCategory } from "types/subCategory";

interface Props {
    disabled: boolean;
    isAd: boolean;
}

const HouseKeepingFields: React.FC<Props> = ({ disabled, isAd }) => {
    const intl = useContext(IntlContext);
    const subcategory = useField("subcategory");

    return (
        <>
        {(subcategory.input.value === SubCategory.CLEANING) && (
            <div className="grid--2 grid--small-1 grid--has-gutter-5x margin-top--3">
                <Radio
                    fieldControlProps={{
                        className: "field-control-radio field__row--inline",
                    }}
                    inputProps={{
                        name: "data.bring_products",
                        required: true,
                        disabled: disabled,
                        options: [
                            {
                                label: intl.formatMessage("generic.label.yes"),
                                value: "1",
                            },
                            {
                                label: intl.formatMessage("generic.label.no"),
                                value: "0",
                            },
                        ],
                    }}
                    labelProps={{
                        label: isAd ? intl.formatMessage("ad.label.bring_yes") : intl.formatMessage("service.label.bring"),
                    }}
                />
            </div>
        )}
        </>
    );
};

export default HouseKeepingFields;
